import { useEffect, useState } from 'react'
import { Box, Card, CardBody, Grid, Stat, StatLabel, StatNumber, Skeleton, Table, Thead, Tbody, Tr, Th, Td, Text } from '@chakra-ui/react'
import ReportPageHeader from '@/components/reports/ReportPageHeader'
import { helpdeskReportService, type ReportFilters } from '@/lib/services/helpdeskReportService'
export default function TicketVolumePage() {
  const [filters, setFilters] = useState<ReportFilters>({ group_by: 'day' })
  const [series, setSeries] = useState<Array<{ date: string; created: number; closed: number }>>([])
  const [bySource, setBySource] = useState<Record<string, number>>({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    helpdeskReportService
      .getVolume(filters)
      .then((res) => {
        setSeries(res.series ?? [])
        setBySource(res.by_source ?? {})
      })
      .finally(() => setLoading(false))
  }, [filters.from, filters.to, filters.group_by])

  const totalCreated = series.reduce((s, r) => s + r.created, 0)
  const totalClosed = series.reduce((s, r) => s + r.closed, 0)

  return (
    <Box p={4}>
      <ReportPageHeader
        title="Ticket Volume"
        subtitle="Created vs closed trends and breakdowns"
        reportType="volume"
        filters={filters}
        onFiltersChange={setFilters}
        showGroupBy
      />

      <Grid templateColumns={{ base: '1fr 1fr', md: 'repeat(3, 1fr)' }} gap={4} mb={6}>
        {loading ? (
          Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} height="80px" />)
        ) : (
          <>
            <Card><CardBody><Stat><StatLabel>Created</StatLabel><StatNumber>{totalCreated}</StatNumber></Stat></CardBody></Card>
            <Card><CardBody><Stat><StatLabel>Closed</StatLabel><StatNumber>{totalClosed}</StatNumber></Stat></CardBody></Card>
            <Card><CardBody><Stat><StatLabel>Sources</StatLabel><StatNumber>{Object.keys(bySource).length}</StatNumber></Stat></CardBody></Card>
          </>
        )}
      </Grid>

      <Card>
        <CardBody>
          <Text fontWeight="semibold" mb={2}>By source</Text>
          <Table size="sm">
            <Thead><Tr><Th>Source</Th><Th>Count</Th></Tr></Thead>
            <Tbody>
              {Object.entries(bySource).map(([src, count]) => (
                <Tr key={src}><Td>{src}</Td><Td>{count}</Td></Tr>
              ))}
            </Tbody>
          </Table>
        </CardBody>
      </Card>
    </Box>
  )
}
